import { FC, useEffect } from 'react';

import { AuthProvider, useIsAuthenticated, useSignIn } from '@updater/auth';
import { getCurrentProfile } from '@updater/identity';
import { useEnvironment } from '../environment';

export const config = { app: 'mover', name: 'provider-app' } as const;

export const ProviderAuth: FC = ({ children }) => {
  const env = useEnvironment();

  return (
    <AuthProvider url={env.updaterAPIURL} headers={config}>
      <ProviderAuthSession>{children}</ProviderAuthSession>
    </AuthProvider>
  );
};

export const ProviderAuthSession: FC = ({ children }) => {
  const isAuthed = useIsAuthenticated();
  const [_request, signIn] = useSignIn();

  useEffect(() => {
    if (!isAuthed)
      signIn({
        type: 'public',
        input: { userUuid: getCurrentProfile()?.updUuid },
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps -- intentionally runs once on mount; signIn is stable

  return <>{children}</>;
};
